module.exports = __webpack_public_path__ + "img/vid.defffb42.svg";